import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions } from 'src/auth';
import Autocomplete from 'react-google-autocomplete';
import { spaceCreationAction } from 'src/create-space';
import { imageUploadAction } from 'src/image-uploader';

import { FormGroup, ControlLabel, HelpBlock, FormControl, Button } from 'react-bootstrap';

import './create-space-page.css';

export class CreateSpacePage extends React.Component {

  constructor(props) {
    super(props);

    this.componentFormKeys = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };

    this.state = ({
      address: null,
      space_title: "",
      description: "",
      rules: "",
      space_type: "",
      amenities: "",
      width: "",
      length: "",
      height: "",
      images: []
    });

    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleRulesChange = this.handleRulesChange.bind(this);
    this.handleSpaceTypeChange = this.handleSpaceTypeChange.bind(this);
    this.handleAmenitiesChange = this.handleAmenitiesChange.bind(this);
    this.handleWidthChange = this.handleWidthChange.bind(this);
    this.handleLengthChange = this.handleLengthChange.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handlePlaceSelected = this.handlePlaceSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleImageToBeUploaded = this.handleImageToBeUploaded.bind(this);
    this.removeImageAtIndex = this.removeImageAtIndex.bind(this);
  }

  handleTitleChange(event) {
    this.setState({space_title: event.target.value});
  }

  handleDescriptionChange(event) {
    this.setState({description: event.target.value});
  }

  handleRulesChange(event) {
    this.setState({rules: event.target.values});
  }

  handleSpaceTypeChange(event) {
    this.setState({space_type: event.target.value});
  }

  handleAmenitiesChange(event) {
    this.setState({amenities: event.target.value});
  }

  handleWidthChange(event) {
    this.setState({width: event.target.value});
  }

  handleLengthChange(event) {
    this.setState({length: event.target.value});
  }

  handleHeightChange(event) {
    this.setState({height: event.target.value});
  }

  handlePlaceSelected(place) {
    let address = place.address_components;
    if (address == null) {
      return;
    }
    var addressComponents = {}
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      if (this.componentFormKeys[addressType]) {
        var val = place.address_components[i][this.componentFormKeys[addressType]];
        addressComponents[addressType] = val;
      }
    }
    console.log(addressComponents)
    this.buildSpaceWith(addressComponents);
  }

  handleSubmit(event) {
    event.preventDefault();
    let formInfo = {
      name: this.state.space_title,
      description: this.state.description,
      space_type: this.state.space_type,
      width: this.state.width,
      length: this.state.length,
      height: this.state.height,
      address: this.state.street_address,
      country: this.state.country,
      zipcode: this.state.zipcode,
      city: this.state.city,
      state: this.state.state,
    }
    console.log(formInfo)
    this.props.createSpace(formInfo);
  }

  buildSpaceWith(addressInfo) {
    let street =
    addressInfo.street_number +
    " " +
    addressInfo.route;

    let parsedAddress = {
      street_address: street,
      country: addressInfo.country,
      zipcode: addressInfo.postal_code,
      city: addressInfo.locality,
      state: addressInfo.administrative_area_level_1
    }
    this.setState(parsedAddress);
  }

  // image upload
  handleImageUpload(event) {
    event.preventDefault();
    var that = this;
    this.state.images.forEach(function(image) {
      that.props.uploadImage(image);
    });
  }

  handleImageToBeUploaded(event) {
    event.preventDefault();
    if (event.target.files.length < 1) {
      return;
    }
    let numOfFiles = event.target.files["length"];
    var imageSet = []
    for(var i = 0; i < numOfFiles; i++) {
     imageSet = imageSet.concat(event.target.files[i]);
    }
    let newImageSet = this.state.images.concat(imageSet);
    this.setState({ images: newImageSet });
  }

  removeImageAtIndex(index) {
    if (this.state.images.length < index) {
      return;
    }
    let newImageSet = this.state.images.splice(index, 1);
    this.setState({ images: newImageSet });
  }

  render() {
    return (
      <div className="div-container">
      <form>
      <div className="form-group">
      <ControlLabel>Enter Address</ControlLabel>
      <Autocomplete
      className="form-control"
      onPlaceSelected={ this.handlePlaceSelected }
      types={['geocode']}
      />
      </div>

      <FormGroup
      controlId="SpaceNameForm">
      <ControlLabel>Space Title</ControlLabel>
      <FormControl
      type="text"
      placeholder="Write a cool title!"
      value={ this.state.space_title }
      onChange={ this.handleTitleChange }
      />
      </FormGroup>

      <FormGroup
      controlId="SpaceDescitionForm">
      <ControlLabel>Description</ControlLabel>
      <FormControl
      componentClass="textarea"
      rows="10"
      placeholder="Enter some interesting facts about your space!"
      value={ this.state.description }
      onChange={ this.handleDescriptionChange }
      />
      </FormGroup>

      <FormGroup
      controlId="SpaceTypeForm">
      <ControlLabel>Space Type</ControlLabel>
      <FormControl
      type="text"
      placeholder="What type of space is this?"
      value={ this.state.space_type }
      onChange={ this.handleSpaceTypeChange }
      />
      </FormGroup>

      <FormGroup
      controlId="formBasicText">
      <ControlLabel>Width</ControlLabel>
      <FormControl
      type="text"
      placeholder="Enter text"
      value={ this.state.width }
      onChange={ this.handleWidthChange }
      />
      </FormGroup>

      <FormGroup
      controlId="formBasicText">
      <ControlLabel>Length</ControlLabel>
      <FormControl
      type="text"
      placeholder="Enter text"
      value={ this.state.length }
      onChange={ this.handleLengthChange }
      />
      </FormGroup>

      <FormGroup
      controlId="formBasicText">
      <ControlLabel>Height</ControlLabel>
      <FormControl
      type="text"
      placeholder="Enter text"
      value={ this.state.height }
      onChange={ this.handleHeightChange }
      />
      </FormGroup>

      <Button
      type="submit"
      onClick={(e) => this.handleSubmit(e)}
      >
      Submit
      </Button>


      <input type="file" onChange={ this.handleImageToBeUploaded } multiple/>
      <Button
      type="submit"
      onClick={(e) => this.handleImageUpload(e)}
      >
      Submit
      </Button>

      {this.state.images.map(image =>
        <label key={image.name}> {image.name} </label>)}

      </form>
      </div>
    );
  }

}

CreateSpacePage.propTypes = {
  createSpace: PropTypes.func.isRequired,
  uploadImage: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  createSpace: spaceCreationAction.createSpaceWithForm,
  uploadImage: imageUploadAction.uploadImage
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(CreateSpacePage)
);



// WEBPACK FOOTER //
// ./src/views/pages/create-space/create-space-page.js